import React from "react";

import { faMinus, faPlus } from "@performyard/fontawesome/pro-regular-svg-icons";
import { ButtonIcon, Text } from "@performyard/py-components";

type AccordionSectionHeaderProps = {
	title: string;
	isExpanded: boolean;
	onToggle: () => void;
	isCollapsible?: boolean;
	/** Optional content rendered left of the expand/collapse toggle (e.g. a status chip). */
	headerAccessory?: React.ReactNode;
};

const AccordionSectionHeader = ({
	title,
	isExpanded,
	onToggle,
	isCollapsible = true,
	headerAccessory,
}: AccordionSectionHeaderProps): React.ReactElement => {
	return (
		<div
			className={`sticky top-0 z-10 flex h-12 items-center justify-between bg-neutral-1 px-4 select-none ${
				isCollapsible ? "cursor-pointer hover:bg-neutral-2" : ""
			}`}
			onClick={isCollapsible ? onToggle : undefined}
		>
			<Text size="paragraph-2" weight="semi-bold">
				{title}
			</Text>
			<div className="flex items-center gap-2">
				{headerAccessory}
				{isCollapsible ? (
					<ButtonIcon
						icon={isExpanded ? faMinus : faPlus}
						color="neutral-7"
						aria-label={isExpanded ? "Collapse section" : "Expand section"}
					/>
				) : null}
			</div>
		</div>
	);
};

export default AccordionSectionHeader;
